import { DefaultState, DropdownItem } from 'store/types';
import { CorporateClientForm } from '../post-corporate-client/types';

export const GET_CORPORATE_CLIENT_REQUEST = 'GET_CORPORATE_CLIENT_REQUEST';
export const GET_CORPORATE_CLIENT_SUCCESS = 'GET_CORPORATE_CLIENT_SUCCESS';
export const GET_CORPORATE_CLIENT_FAILURE = 'GET_CORPORATE_CLIENT_FAILURE';
export const GET_CORPORATE_CLIENT_CLEAR = 'GET_CORPORATE_CLIENT_CLEAR';

export interface CorporateClientFormData extends CorporateClientForm {
  reportTypesSelectList: DropdownItem[];
  reportDatesSelectList: DropdownItem[];
  weekDaysSelectList: DropdownItem[];
  userEmailsSelectList: DropdownItem[];
}

export type GetCorporateClientState = DefaultState & {
  contents?: CorporateClientFormData;
};

interface GetCorporateClientRequest {
  type: typeof GET_CORPORATE_CLIENT_REQUEST;
}

interface GetCorporateClientSuccess {
  type: typeof GET_CORPORATE_CLIENT_SUCCESS;
  contents: CorporateClientFormData;
}

interface GetCorporateClientFailure {
  type: typeof GET_CORPORATE_CLIENT_FAILURE;
}

interface GetCorporateClientClear {
  type: typeof GET_CORPORATE_CLIENT_CLEAR;
}

export type GetCorporateClientActionTypes = GetCorporateClientRequest | GetCorporateClientSuccess | GetCorporateClientFailure | GetCorporateClientClear;